module.exports = __webpack_public_path__ + "static/media/Logo.e78fc3f5.svg";